import {
  buildOptionalParams,
  buildPath,
  buildTemplatePath,
  CrudMode,
  Dialog,
  handleClose,
  PageRoute,
  ScreenType,
  useParams,
  useUnsavedChanges,
  useValidationErrors,
} from "@compass/core";
import { Grade, GradeViewResource, Permission } from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { GradePageBody } from "./GradePageBody";
import { GradePageHeader } from "./GradePageHeader";

const routeName = "grade";

class Params {
  id: number = 0;
  crudMode: CrudMode = "view";
  screenType: ScreenType = "standard";
}

export const gradePageRoute: PageRoute<Params> = {
  handle: "Course Grade",
  templatePath: buildTemplatePath(routeName, Params),
  getPath: (params) => buildPath(routeName, params),
};

export const GradePage = () => {
  const ROOT_PERMISSION: Permission = Permission.SystemUtility;
  const navigate = useNavigate();
  const { params } = useParams(routeName, Params);
  const [grade, setGrade] = useState<Grade>({} as Grade);
  const [initGrade, setInitGrade] = useState<Grade>(grade);
  const [viewResource, setViewResource] = useState<GradeViewResource>({});
  const { unsavedChanges, resetUnsavedChanges } = useUnsavedChanges({ trackedItems: [grade] });
  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    fetch(params.id);

    ApiService.grades.getViewResource().then((response) => {
      setViewResource(response);
    });
  }, []);

  const reroute = (id: number, crudMode: CrudMode) =>
    navigate(`../${gradePageRoute.getPath({ id: id, crudMode: crudMode, screenType: params.screenType, })}`);

  const fetch = (id: number) => {
    ApiService.grades.get(id).then((response) => {
      setGrade(response);
      setInitGrade(response);
      resetUnsavedChanges([response]);
    });
  };

  return (
    <Dialog
      isForm
      open={true}
      onClose={() => handleClose(navigate, unsavedChanges)}
      maxWidth="md"
      header={
        <GradePageHeader
          rootPermission={ROOT_PERMISSION}
          handle={gradePageRoute.handle}
          crudMode={params.crudMode}
          reroute={reroute}
          fetch={fetch}
          grade={grade}
          setGrade={setGrade}
          initGrade={initGrade}
          setValidationErrors={setValidationErrors}
          unsavedChanges={unsavedChanges}
          resetUnsavedChanges={resetUnsavedChanges}
        />
      }
      content={
        <GradePageBody
          grade={grade}
          setGrade={setGrade}
          viewResource={viewResource}
          crudMode={params.crudMode}
          validationErrors={validationErrors}
        />
      }
    />
  );
};
